var exports = {
  "kL": "x61f99309--fccaec--container",
  "Tq": "x61f99309--fccaec--bubble",
  "hD": "x61f99309--fccaec--quote",
  "ZY": "x61f99309--fccaec--meta-overlay",
};

module.exports = exports;
